import { shallow } from 'zustand/shallow';

import { VariablesButton } from '../../logic/variables/VariablesButton';

import { useI18n } from '../../../hooks/useI18nFormatters';

import { glyph } from '../../../theme/glyph';
import { theme } from '../../../theme/theme';

import { DualButtonRound } from '../../../components/buttons/DualButtonRound';
import { HeaderActionsContainer } from '../../../components/header/HeaderActionsContainer';

import { AddCardButton } from './AddCardButton';
import { SaveButton } from './SaveButton';
import { advancedFlowViewStore, AdvancedFlowViewStore } from './store/AdvancedFlowViewStore';

function selectActionsDependencies(state) {
  return {
    history: state.history,
    historyIndex: state.historyIndex,
    hasStartCard: state.hasStartCard,
    conditionSave: state.conditionSave,
    advancedFlow: state.advancedFlow,
    initialAdvancedFlow: state.initialAdvancedFlow,
  };
}

function useActionsDependencies() {
  return advancedFlowViewStore.store(selectActionsDependencies, shallow);
}

export function AdvancedFlowActions(props) {
  const { i18n } = useI18n();
  const { history, historyIndex, conditionSave, hasStartCard, advancedFlow, initialAdvancedFlow } =
    useActionsDependencies();

  const canUndo = history[historyIndex - 1] != null;
  const canRedo = history[historyIndex + 1] != null;

  const hasUnsavedChanges = advancedFlow !== initialAdvancedFlow;
  const isSaving = conditionSave === AdvancedFlowViewStore.conditionSave.saving;

  function handleSavePress() {
    advancedFlowViewStore
      .saveAdvancedFlow({
        route: true,
      })
      .catch(console.error);
  }

  function handleUndo() {
    advancedFlowViewStore.undo();
  }

  function handleRedo() {
    advancedFlowViewStore.redo();
  }

  return (
    <HeaderActionsContainer>
      <SaveButton
        hasUnsavedChanges={hasUnsavedChanges}
        isSaving={isSaving}
        onPress={handleSavePress}
      />
      <DualButtonRound>
        <DualButtonRound.Part
          title={i18n.messageFormatter('common.undo')}
          isDisabled={canUndo === false || isSaving}
          onPress={handleUndo}
        >
          <DualButtonRound.Icon
            source={glyph.core.arrowCounterclockwise}
            color={theme.color.icon_dark}
            size={theme.icon.size_default}
          />
        </DualButtonRound.Part>
        <DualButtonRound.Part
          title={i18n.messageFormatter('common.redo')}
          isDisabled={canRedo === false || isSaving}
          onPress={handleRedo}
        >
          <DualButtonRound.Icon
            source={glyph.core.arrowClockwise}
            color={theme.color.icon_dark}
            size={theme.icon.size_default}
          />
        </DualButtonRound.Part>
      </DualButtonRound>

      <VariablesButton />
      <AddCardButton hasStartCard={hasStartCard} />
    </HeaderActionsContainer>
  );
}
